var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('a',{attrs:{"href":`/admin/pages/floors/${_vm.item.id}`}},[_c('span',{staticClass:"text-nowrap inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-pink-100 text-pink-800"},[_vm._v("\n        "+_vm._s(_vm.item.name)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }